<div class="card">
    <div class="card-header" role="tab" id="headingLeftOne">
        <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Product Info</h5>
            <button *ngIf="canEdit && !isEditing" class="btn btn-sm btn-primary" (click)="isEditing = true">
                <i class="fa fa-edit"></i> Change Product
            </button>
        </div>
    </div>
    <div *ngIf="canEdit && isEditing" class="p-2 border-bottom">
        <div class="d-flex align-items-center">
            <ng-select
                [items]="products"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="selectedProductId"
                placeholder="Seleccionar producto"
                style="width: 70%">
            </ng-select>
            <button class="btn btn-success ml-2" (click)="saveProduct()">
                <i class="fa fa-save"></i>
            </button>
            <button class="btn btn-success ml-2"  (click)="isEditing = false">
                <i class="fa fa-remove"></i>
            </button>
        </div>
    </div>
    <div
        id="collapseLeftOne"
        class="collapse show"
        role="tabpanel"
        aria-labelledby="headingLeftOne"
        data-parent="#accordion"
    >
        <div class="card-body">
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Name</strong><span>{{ product?.name }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Weeks</strong><span>{{ product?.weeks }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Interest Rate</strong><span>{{ product?.interest_rate }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Late Fee Amount</strong><span>{{ product?.late_fee_amount }} €</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Visible</strong><span>{{ product?.visible ? 'Si' : 'No' }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Contract Name</strong><span>{{ product?.contract?.name}}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Eu Form Name</strong><span>{{ product?.eu_form?.name}}</span>
                </li>
            </ul>
        </div>
    </div>
</div>
